import styled from "styled-components";

export const AuthModalBottomDescription = styled.div`
  color: ${({ theme }) => theme.authModal.secondaryText};
  font: 400 0.813rem/1.219rem "Inter";
  text-align: center;

  p {
    all: unset;
  }

  b,
  strong {
    color: ${({ theme }) => theme.authModal.primaryText};
    font-weight: 500;
  }
`;
